<template>

    <nav-bar :returnAction="true" :saveAction="true" :pageName="'Cadastro de Paciente'" @save="execute" @return="$router.push(`/patients`)" />

    <main-container :onlyNav="true">

        <div class="row w-100">
            <div class="col-sm-12 col-md-12 col-lg-6 mb-1">
                <label for="recipient-name" class="form-label">Nome</label>
                <input type="text" class="form-control" v-model="patientStore.patient.name" @blur="patientStore.patientNameExists(patientStore.patient.name)">
                <small class="red" v-if="patientStore.showMessageNameExists">Nome já esta em uso!</small>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 mb-1">
                <label for="recipient-name" class="form-label">Email</label>
                <input type="text" class="form-control" v-model="patientStore.patient.email">
            </div>
             <div class="col-sm-12 col-md-6 col-lg-4 mb-1">
                <label for="recipient-name" class="form-label">Data de Nascimento</label>
                <input type="date" class="form-control" v-model="patientStore.patient.birthDate">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4 mb-1">
                <label for="recipient-name" class="form-label">Fone</label>
                <input type="text" class="form-control" v-model="patientStore.patient.phone">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4 mb-1">
                <label for="recipient-name" class="form-label">Fone 2</label>
                <input type="text" class="form-control" v-model="patientStore.patient.phone2">
            </div>
            <div class="col-sm-12 col-md-3 mb-3">
                <label for="recipient-name" class="form-label">Valor da Sessão</label>
                <input type="number" class="form-control" v-model="patientStore.patient.sessionValue" min="1">
            </div>
            <div class="col-sm-12 col-md-3 mb-3" >
                <label for="recipient-name" class="form-label">Dia de Pagamento</label>
                <select class="form-select" v-model="patientStore.patient.payday">
                    <option v-for="(obj, index) in paydays" :value="obj.key" :key="index">{{`${obj.value}`}}</option>
                </select>
            </div>
            <div class="col-sm-12 col-md-3 mb-3">
                <label for="recipient-name" class="form-label">Número de Sessões</label>
                <input type="number" class="form-control" v-model="patientStore.patient.numberOfSessions" min="1">
            </div>
            <div class="col-sm-12 col-md-3 mb-3" v-if="executeMethod == 'update'">
                <label for="recipient-name" class="form-label">Situação</label>
               <select class="form-select" v-model="patientStore.patient.situation">
                    <option v-for="(obj, index) in situations" :value="obj.key" :key="index">{{`${obj.value}`}}</option>
                </select>
            </div>
            <div class="col-sm-12 mb-1">
                <label class="form-label">Observação</label>
                <textarea class="form-control textarea" v-model="patientStore.patient.note" placeholder="Informe uma Observação"></textarea>
            </div>
        </div>

    </main-container>

</template>

<script>
import { showErrorNotifications } from "../../services/popups";
import { usePatientStore } from "../../store/patient";
import { useUserStore } from '../../store/user';

export default {
    name: "PatientCrudView",
    inject:["mySpinner"],    
    setup() {
        const patientStore  = usePatientStore();
        const userStore  = useUserStore();
        return { patientStore, userStore }
    },    
    async mounted() {
        this.patientStore.clean();

        if (this.patientId == "create") {                        
            this.executeMethod = "create";
        }
        else {
            this.mySpinner.loading = true;
            await this.patientStore.getPatientById(this.patientId);
            this.mySpinner.loading = false;
            this.executeMethod = "update";
        }
    },
    props: {
       patientId: {type: String}
    },
    data() {
        return {            
            executeMethod: "create",            
            paydays:[{key: -1, value:"Por Consulta"}, {key:1, value:1}, {key:5, value:5}, {key:10, value:10}, {key:15, value:15}, {key:20, value:20}, {key:25, value:25}, {key:31, value:"Último dia do Mês"}],
            situations:[{key:1, value:"Ativo"}, {key:2, value:"Inativo"}, {key:3, value:"Alta"}, {key:4, value:"Bloqueado"}]
        }
    },
    methods: {
        cleanFields() {
            this.showMessageNameExists = false;            
        },
        async execute() {
            if (this.executeMethod == "create") {
                await this.executeCreate();
            }
            else {
                await this.executeUpdate();
            }
        },
        async executeCreate() {

            let notifications = [];

            if (!this.patientStore.patient.name) {
                notifications.push({key:"Name", message:"O Nome é obrigatório!"});
            }

            if (!this.patientStore.patient.email) {
                notifications.push({key:"Email", message:"O Email é obrigatório!"});
            }

            if (!this.patientStore.patient.birthDate) {
                notifications.push({key:"BirthDate", message:"A Data de nascimento deve ser informada!"});
            }

            if (!this.patientStore.patient.phone) {
                notifications.push({key:"Phone", message:"O Fone deve ser informado"});
            }

            if (!this.patientStore.patient.numberOfSessions || this.patientStore.patient.numberOfSessions < 1) {
                notifications.push({key:"NumberOfSessions", message:"Número de Sessões inválido, deve ser no mínimo 1!"});
            }
            
            if (notifications.length > 0) {
                showErrorNotifications(notifications);
                return;
            }            

            this.patientStore.postPatient({...this.patientStore.patient, clinicId:this.userStore.getUser.clinicId});
        },
        async executeUpdate() {

            let notifications = [];

            if (!this.patientStore.patient.name) {
                notifications.push({key:"Name", message:"O Nome é obrigatório!"});
            }

            if (!this.patientStore.patient.email) {
                notifications.push({key:"Email", message:"O Email é obrigatório!"});
            }

            if (!this.patientStore.patient.birthDate) {
                notifications.push({key:"BirthDate", message:"A Data de nascimento deve ser informada!"});
            }

            if (!this.patientStore.patient.phone) {
                notifications.push({key:"Phone", message:"O Fone deve ser informado"});
            }

            if (!this.patientStore.patient.numberOfSessions || this.patientStore.patient.numberOfSessions < 1) {
                notifications.push({key:"NumberOfSessions", message:"Número de Sessões inválido, deve ser no mínimo 1!"});
            }

            if (!this.patientStore.patient.situation || this.patientStore.patient.situation < 1) {
                notifications.push({key:"Situation", message:"Situação inválida, selecione uma situação!"});
            }
           
            if (notifications.length > 0) {
                showErrorNotifications(notifications);
                return;
            }           

            this.patientStore.putPatient({...this.patientStore.patient, clinicId:this.userStore.getUser.clinicId});
        },                      
    },    
}
</script>


<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_patients';
</style>

